import React from 'react';
import PropTypes from 'prop-types';
import './FactRow.css';

/**
 * FactRow — one read-only fact: a label over its value, with an optional
 * helper line and a leading icon; `boxed` draws it in a hairline box (the
 * account e-mail that is shown, never edited).
 */
const FactRow = ({ icon, label, value, helper, boxed = false, className = '' }) => (
  <div className={['ds-fact-row', boxed && 'ds-fact-row--boxed', className].filter(Boolean).join(' ')}>
    {icon && <span className="ds-fact-row__icon" aria-hidden="true">{icon}</span>}
    <dl className="ds-fact-row__text">
      <dt className="ds-fact-row__label typo-body-sm">{label}</dt>
      <dd className="ds-fact-row__value typo-body">{value}</dd>
      {helper && <dd className="ds-fact-row__helper typo-body-sm">{helper}</dd>}
    </dl>
  </div>
);

FactRow.propTypes = {
  /** Leading icon (20px) */
  icon: PropTypes.node,
  label: PropTypes.node.isRequired,
  value: PropTypes.node.isRequired,
  /** Muted line under the value */
  helper: PropTypes.node,
  /** Hairline box around the row */
  boxed: PropTypes.bool,
  className: PropTypes.string,
};

export default FactRow;
